var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-card',{attrs:{"ripple":"","to":_vm.link}},[_c('v-card-text',{staticClass:"text-truncate"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-plus")]),_c('span',{staticClass:"body-2 icon-text-offset"},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }